import React, { ReactNode } from 'react';
import StatusIcon from '../../StatusIcon/StatusIcon';
import './ToasterWithStatusAndDescription.scss';

interface ToasterWithStatusAndDescriptionProps {
    title: string;
    status: 'success' | 'error' | 'pending';
    description: ReactNode;
}

const ToasterWithStatusAndDescription: React.FC<ToasterWithStatusAndDescriptionProps> = ({ title, status, description }) => {

    return (
        <div className="ToasterWithStatusAndDescription">
            <h3 className="nereus-body-m mb-1.5">{title}</h3>
            <p className={`nereus-callout capitalize ToasterWithStatusAndDescription__${status}`}>{status} <StatusIcon className="inline" status={status} /> </p>
            <div className="mt-4 nereus-callout">{description}</div>
        </div>
    );
};

export default ToasterWithStatusAndDescription;
